import { isFeatureEnabled } from 'owa-feature-flags';
import { getApplicationSettings } from 'owa-application-settings';

export const baseUrl = '/PeopleGraph/v1.0/contacts';

export const isEnabled = () => {
    return isFeatureEnabled('fwk-application-settings')
        ? getApplicationSettings('CAPIv3').isCAPIv3Enabled
        : false;
};
